const header = "_ibqhqn2liu";
const selectTooltip = "_ibqs8yt92i";

export { header, selectTooltip };
import "./molecule.revision-select.style.linaria.module.css";
//# sourceMappingURL=molecule.revision-select.style.js.map
